import { render, staticRenderFns } from "./zhutu.vue?vue&type=template&id=4c5f89b6&scoped=true&"
import script from "./zhutu.vue?vue&type=script&lang=js&"
export * from "./zhutu.vue?vue&type=script&lang=js&"
import style0 from "./zhutu.vue?vue&type=style&index=0&id=4c5f89b6&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5f89b6",
  null
  
)

export default component.exports